import {ShareScreenIcon} from '@100mslive/react-icons';
import {
  selectIsAllowedToPublish,
  useCustomEvent,
  useHMSActions,
  useHMSStore,
  useScreenShare,
} from '@100mslive/react-sdk';
import {config, IconButton, Tooltip} from '@100mslive/roomkit-react';
import {useEffect} from 'react';
import {useUISettings} from '../AppData/useUISettings';
import {REMOTE_STOP_SCREENSHARE_TYPE, UI_SETTINGS} from '../common/constants';
import {isScreenshareSupported} from '../common/utils';

export const ScreenshareToggle = ({css,isMobile}: any) => {
  const isAllowedToPublish = useHMSStore(selectIsAllowedToPublish);
  const isAudioOnly = useUISettings(UI_SETTINGS.isAudioOnly);
  const actions = useHMSActions();
  const {
    amIScreenSharing,
    screenShareVideoTrackId: video,
    toggleScreenShare,
  } = useScreenShare();
  const { sendEvent } = useCustomEvent({
    type: REMOTE_STOP_SCREENSHARE_TYPE,
  });
  const isVideoScreenshare = amIScreenSharing && !!video;
  if (!isAllowedToPublish.screen || !isScreenshareSupported()) {
    return null;
  }

  const handleShareScreenToggle = async () =>{
    if (toggleScreenShare) {
      // const resp =  await toggleScreenShare();
      const errResp = await actions.setScreenShareEnabled(!amIScreenSharing, {
        audioOnly: false,
        videoOnly: true
    })
      sendEvent({})
    }
  }
  return (
    <Tooltip title={`${!isVideoScreenshare ? 'Start' : 'Stop'} Screen sharing`}>
      <div style={{backgroundColor:!isVideoScreenshare?'':'',padding:4,borderRadius:4,marginTop:3,marginLeft:10}}>
        <div style={{cursor:'pointer',display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom:7}} data-testid="screen_share_btn" aria-disabled={isAudioOnly} onClick={handleShareScreenToggle}>
          {isVideoScreenshare ? <img
            src={require('../../asset/icons/stopShare.png')}
            alt='logo'
            width='20px'
          />: <img
            src={require('../../asset/icons/share.png')}
            alt='logo'
            width='20px'
          />}
        </div>
        <div style={{fontSize:12,marginTop:3,color: 'white'}}>{!isVideoScreenshare ? 'Share' : 'Stop Sharing'}</div>
      </div>
    </Tooltip>
  );
};
